module.exports = __webpack_public_path__ + "952032040a572c19e54b38c7b7c883a8.svg";